// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat History Sidebar Styles */
.chat-history-drawer .ant-drawer-body {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.chat-history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.chat-history-header-top {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
}

.close-drawer-btn {
    padding: 4px;
}

.chat-history-sidebar {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
}

.research-container {
    display: flex;
    height: 100%;
    align-items: center;
}

.text_name {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
}

.chat-history-actions {
    padding: 12px;
    border-bottom: 1px solid #f0f0f0;
}

.new-chat-btn {
    height: 40px;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chat-history-search {
    padding: 12px;
    border-bottom: 1px solid #f0f0f0;
}

.chat-history-list-container {
    flex: 1 1;
    overflow-y: auto;
    padding: 8px 0;
}

.chat-history-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    padding: 20px;
}

.chat-history-item {
    padding: 0 !important;
    margin: 4px 8px !important;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid transparent;
}

.chat-history-item:hover {
    background-color: #f5f5f5;
}

.chat-history-item.active {
    background-color: #e6f7ff;
    border-color: #1890ff;
}

.chat-history-item-content {
    width: 100%;
    padding: 12px;
}

.chat-history-item-header {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
    min-width: 0;
}

.chat-icon {
    color: #1890ff;
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
}

.chat-history-item-title {
    flex: 1 1;
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    line-height: 1.4;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.chat-history-item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
}

.chat-history-date {
    font-size: 12px;
    color: #8c8c8c;
}

.delete-chat-btn {
    opacity: 0;
    transition: opacity 0.2s;
    color: #ff4d4f;
}

.chat-history-item:hover .delete-chat-btn {
    opacity: 1;
}

.chat-history-footer {
    padding: 12px;
    border-top: 1px solid #f0f0f0;
}

.clear-all-btn {
    color: #ff4d4f;
    font-size: 13px;
}

.clear-all-btn:hover {
    background-color: #fff1f0;
}

/* Dark theme support */
[data-theme="dark"] .chat-history-sidebar {
    background: #1f1f1f;
}

[data-theme="dark"] .chat-history-header {
    border-bottom-color: #303030;
    color: #fff;
}

[data-theme="dark"] .chat-history-actions,
[data-theme="dark"] .chat-history-search {
    border-bottom-color: #303030;
}

[data-theme="dark"] .chat-history-item:hover {
    background-color: #2a2a2a;
}

[data-theme="dark"] .chat-history-item.active {
    background-color: #111b26;
    border-color: #1890ff;
}

[data-theme="dark"] .chat-history-item-title {
    color: #fff;
}

[data-theme="dark"] .chat-history-date {
    color: #8c8c8c;
}

[data-theme="dark"] .chat-history-footer {
    border-top-color: #303030;
}

/* Scrollbar styling */
.chat-history-list-container::-webkit-scrollbar {
    width: 6px;
}

.chat-history-list-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.chat-history-list-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.chat-history-list-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

[data-theme="dark"] .chat-history-list-container::-webkit-scrollbar-track {
    background: #2a2a2a;
}

[data-theme="dark"] .chat-history-list-container::-webkit-scrollbar-thumb {
    background: #555;
}

[data-theme="dark"] .chat-history-list-container::-webkit-scrollbar-thumb:hover {
    background: #777;
}

/* Chat History Toggle Button */
.chat-history-toggle-btn {
    background: #071E31 !important;
    border-color: #071E31 !important;
    color: #fff !important;
    border-radius: 6px !important;
    font-weight: 500;
    height: 36px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.chat-history-toggle-btn:hover {
    background: #0a2540 !important;
    border-color: #0a2540 !important;
}

.section-headding {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Mobile responsive */
@media (max-width: 768px) {
    .chat-history-drawer {
        width: 100% !important;
        max-width: 320px;
    }

    .chat-history-toggle-btn {
        font-size: 12px;
        padding: 0 12px;
        height: 32px;
    }

    .section-headding h4 {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatHistorySidebar.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Chat History Sidebar Styles */\n.chat-history-drawer .ant-drawer-body {\n    padding: 0 !important;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.chat-history-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.chat-history-header-top {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.close-drawer-btn {\n    padding: 4px;\n}\n\n.chat-history-sidebar {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background: #fff;\n}\n\n.research-container {\n    display: flex;\n    height: 100%;\n    align-items: center;\n}\n\n.text_name {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.chat-history-actions {\n    padding: 12px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.new-chat-btn {\n    height: 40px;\n    font-weight: 500;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.chat-history-search {\n    padding: 12px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.chat-history-list-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px 0;\n}\n\n.chat-history-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n    padding: 20px;\n}\n\n.chat-history-item {\n    padding: 0 !important;\n    margin: 4px 8px !important;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n    border: 1px solid transparent;\n}\n\n.chat-history-item:hover {\n    background-color: #f5f5f5;\n}\n\n.chat-history-item.active {\n    background-color: #e6f7ff;\n    border-color: #1890ff;\n}\n\n.chat-history-item-content {\n    width: 100%;\n    padding: 12px;\n}\n\n.chat-history-item-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 8px;\n    min-width: 0;\n}\n\n.chat-icon {\n    color: #1890ff;\n    font-size: 16px;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.chat-history-item-title {\n    flex: 1;\n    font-size: 14px;\n    font-weight: 500;\n    color: #262626;\n    line-height: 1.4;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n.chat-history-item-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 8px;\n}\n\n.chat-history-date {\n    font-size: 12px;\n    color: #8c8c8c;\n}\n\n.delete-chat-btn {\n    opacity: 0;\n    transition: opacity 0.2s;\n    color: #ff4d4f;\n}\n\n.chat-history-item:hover .delete-chat-btn {\n    opacity: 1;\n}\n\n.chat-history-footer {\n    padding: 12px;\n    border-top: 1px solid #f0f0f0;\n}\n\n.clear-all-btn {\n    color: #ff4d4f;\n    font-size: 13px;\n}\n\n.clear-all-btn:hover {\n    background-color: #fff1f0;\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .chat-history-sidebar {\n    background: #1f1f1f;\n}\n\n[data-theme=\"dark\"] .chat-history-header {\n    border-bottom-color: #303030;\n    color: #fff;\n}\n\n[data-theme=\"dark\"] .chat-history-actions,\n[data-theme=\"dark\"] .chat-history-search {\n    border-bottom-color: #303030;\n}\n\n[data-theme=\"dark\"] .chat-history-item:hover {\n    background-color: #2a2a2a;\n}\n\n[data-theme=\"dark\"] .chat-history-item.active {\n    background-color: #111b26;\n    border-color: #1890ff;\n}\n\n[data-theme=\"dark\"] .chat-history-item-title {\n    color: #fff;\n}\n\n[data-theme=\"dark\"] .chat-history-date {\n    color: #8c8c8c;\n}\n\n[data-theme=\"dark\"] .chat-history-footer {\n    border-top-color: #303030;\n}\n\n/* Scrollbar styling */\n.chat-history-list-container::-webkit-scrollbar {\n    width: 6px;\n}\n\n.chat-history-list-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.chat-history-list-container::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n}\n\n.chat-history-list-container::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n[data-theme=\"dark\"] .chat-history-list-container::-webkit-scrollbar-track {\n    background: #2a2a2a;\n}\n\n[data-theme=\"dark\"] .chat-history-list-container::-webkit-scrollbar-thumb {\n    background: #555;\n}\n\n[data-theme=\"dark\"] .chat-history-list-container::-webkit-scrollbar-thumb:hover {\n    background: #777;\n}\n\n/* Chat History Toggle Button */\n.chat-history-toggle-btn {\n    background: #071E31 !important;\n    border-color: #071E31 !important;\n    color: #fff !important;\n    border-radius: 6px !important;\n    font-weight: 500;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.chat-history-toggle-btn:hover {\n    background: #0a2540 !important;\n    border-color: #0a2540 !important;\n}\n\n.section-headding {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n    .chat-history-drawer {\n        width: 100% !important;\n        max-width: 320px;\n    }\n\n    .chat-history-toggle-btn {\n        font-size: 12px;\n        padding: 0 12px;\n        height: 32px;\n    }\n\n    .section-headding h4 {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
